import OpenInNew from '@mui/icons-material/OpenInNew'
import { Box } from '@mui/material'
import { DataGridPremium, GridActionsCellItem } from '@mui/x-data-grid-premium'
import type { CountryGroupResponse } from './endpoints/spend-control'

export const CountryGroupTranslationsTable = ({
  countryGroups,
  onEditCountryGroup,
}: {
  countryGroups: CountryGroupResponse[] | undefined
  onEditCountryGroup: (countryGroup: CountryGroupResponse) => void
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    <DataGridPremium
      rows={countryGroups ?? []}
      getRowId={(row) => row.countryGroupId}
      columns={[
        { field: 'countryGroupId', headerName: 'ID' },
        { field: 'name', headerName: 'Name', flex: 1 },
        {
          field: 'actions',
          type: 'actions',
          width: 64,
          getActions: ({ row }: { row: CountryGroupResponse }) => [
            <GridActionsCellItem key="view" icon={<OpenInNew />} label="View" onClick={() => onEditCountryGroup(row)} />,
          ],
        },
      ]}
      disableRowSelectionOnClick
      hideFooter
      getRowHeight={() => 'auto'}
      sx={{ '& .MuiDataGrid-cell': { display: 'flex', alignItems: 'center' } }}
    />
  </Box>
)
